import './Gift.scss'
import { CuiTag } from 'front-lib'
import { getColor } from 'src/utils/gifts'
import { GiftProps } from 'src/types/gifts'

const Gift = ({ title, image, tags, quantity }: GiftProps) => {
  const showQuantity = quantity > 1
  return (
    <div className="gift">
      <div className="gift__content">
        <img src={image.url} alt="gift" className="gift__content__image" />
        <div className="gift__content__right_column">
          <div className="gift__content__title">{title.value}</div>
          <div className="gift__tags">
            {tags.map(tag => (
              <CuiTag
                key={tag.text}
                color={getColor(tag.backgroundColor)}
                fill="solid"
                size="small"
                className="gift__content__tag">
                <span>{tag.text}</span>
              </CuiTag>
            ))}
          </div>
        </div>
      </div>
      {showQuantity && <div className="gift__quantity">{quantity}</div>}
    </div>
  )
}

export default Gift
